import React from "react";
var __jsx = React.createElement;
import { Dialog } from '@material-ui/core';
import uniqBy from 'lodash/uniqBy';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Loader from 'components/common/Loader';
import { useGenerateUrls } from 'libs/content/hooks';
import { filterDisplayableUrls } from 'libs/content/utils';
import { getUrls } from 'redux/content';
import { CloseButton, Container, Content, Description, Title } from './PublishDialog.style';
import { PublicationActionButtons, PublishedStatus, SchedulePublication } from './index';

var usePublicationUrls = function usePublicationUrls(isModalOpened) {
  var _useSelector = useSelector(getUrls),
      getUrlsLoading = _useSelector.loading,
      existingUrls = _useSelector.value;

  var _useGenerateUrls = useGenerateUrls(),
      generateUrlsLoading = _useGenerateUrls.loading,
      generatedUrls = _useGenerateUrls.urls,
      doGenerateUrls = _useGenerateUrls.doGenerateUrls;

  useEffect(function () {
    if (isModalOpened) {
      void doGenerateUrls();
    }
  }, [isModalOpened, doGenerateUrls]);
  var publicationUrls = uniqBy((existingUrls !== null && existingUrls !== void 0 ? existingUrls : []).concat(generatedUrls !== null && generatedUrls !== void 0 ? generatedUrls : []), 'pageType');
  var displayablePublicationUrls = filterDisplayableUrls(publicationUrls);
  return {
    loading: getUrlsLoading || generateUrlsLoading,
    urls: displayablePublicationUrls
  };
};

var PublishDialog = function PublishDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      publicationStatus = _ref.publicationStatus,
      publishingLoading = _ref.publishingLoading,
      initialScheduledDate = _ref.initialScheduledDate;
  var intl = useIntl();

  var _useState = useState(false),
      schedulePublication = _useState[0],
      setSchedulePublication = _useState[1];

  var _useState2 = useState(undefined),
      scheduledDate = _useState2[0],
      setScheduledDate = _useState2[1];

  var _usePublicationUrls = usePublicationUrls(open),
      urlsLoading = _usePublicationUrls.loading,
      potentialUrls = _usePublicationUrls.urls;

  useEffect(function () {
    setScheduledDate(initialScheduledDate !== null && initialScheduledDate !== void 0 ? initialScheduledDate : undefined);
  }, [initialScheduledDate]);

  var handleScheduleConfirm = function handleScheduleConfirm(newStatus) {
    onConfirm(newStatus, scheduledDate);
    setSchedulePublication(false);
  };

  var handleDateChange = function handleDateChange(choosenDate) {
    if (choosenDate !== undefined) {
      setScheduledDate(choosenDate);
    }
  };

  var handleBack = function handleBack() {
    return setSchedulePublication(false);
  };

  var PublishDialogContent = function PublishDialogContent() {
    switch (true) {
      case publishingLoading:
        return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
          id: "publish-modal.title",
          tagName: Title
        }), __jsx(Loader, null));

      case schedulePublication:
        return __jsx(SchedulePublication, {
          publicationStatus: publicationStatus,
          scheduledDate: scheduledDate,
          handleChange: handleDateChange,
          onConfirm: handleScheduleConfirm,
          onBack: handleBack
        });

      default:
        return __jsx(React.Fragment, null, __jsx(PublishedStatus, {
          publicationStatus: publicationStatus
        }), __jsx(FormattedMessage, {
          id: "publish-modal.title",
          tagName: Title
        }), __jsx(Content, null, __jsx(FormattedMessage, {
          id: "publish-modal.online.published-path",
          tagName: Description
        }), urlsLoading ? __jsx(Loader, null) : potentialUrls !== undefined && __jsx("ul", null, potentialUrls.map(function (_ref2) {
          var absoluteUrl = _ref2.absoluteUrl,
              pageConfigName = _ref2.pageConfigName;
          return __jsx("li", {
            key: pageConfigName
          }, absoluteUrl);
        })), __jsx(PublicationActionButtons, {
          publicationStatus: publicationStatus,
          onConfirm: onConfirm,
          setSchedulePublication: setSchedulePublication
        })));
    }
  };

  return __jsx(Dialog, {
    open: open,
    onClose: onClose
  }, __jsx(Container, null, __jsx(CloseButton, {
    onClick: onClose,
    role: "button",
    "aria-label": intl.formatMessage({
      id: 'publish-modal.close-button-label'
    })
  }), __jsx(PublishDialogContent, null)));
};

export default PublishDialog;